var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStrikethrough = function SvgStrikethrough(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85813 0.818182H8.09109V7.55966C8.09109 8.25568 7.92702 8.87713 7.5989 9.42401C7.27409 9.96757 6.81505 10.3968 6.22177 10.7116C5.62849 11.0232 4.93247 11.179 4.1337 11.179C3.33493 11.179 2.63891 11.0232 2.04563 10.7116C1.45236 10.3968 0.991655 9.96757 0.66353 9.42401C0.338719 8.87713 0.176314 8.25568 0.176314 7.55966V0.818182H1.40927V7.46023C1.40927 7.95739 1.51864 8.39986 1.73739 8.78764C1.95614 9.17211 2.2677 9.47538 2.67205 9.69744C3.07972 9.91619 3.56694 10.0256 4.1337 10.0256C4.70046 10.0256 5.18768 9.91619 5.59535 9.69744C6.00302 9.47538 6.31457 9.17211 6.53001 8.78764C6.74876 8.39986 6.85813 7.95739 6.85813 7.46023V0.818182Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: "50%",
    width: 11,
    height: 1,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStrikethrough);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "strikethrough.ef4a98713b58aed82e18141a2f27b4f0.svg";